module.exports = __webpack_public_path__ + "d0bd560f435f61ac2fae0645025c482e.png";